import React from 'react';
import Moment from 'moment';
import { saveChanges, publishSite } from 'RLX/State/Content/ContentActions';

function AppMenu ({ ui }) {
  const { savedTime } = ui;
  const savedString = savedTime ? Moment(savedTime).format('LT') : null;
  return [
    {
      text: savedTime
        ? <span>Last Saved At <b>{savedString}</b></span>
        : <small>MENU</small>,
      icon: savedTime ? 'calendar-check-o' : 'hand-peace-o'
    },
    {
      url: '/',
      text: 'Visit Site',
      icon: 'external-link',
      target: '_blank'
    },
    {
      text: 'Commit Changes',
      icon: 'save',
      onClick: saveChanges
    },
    {
      text: 'Publish Changes',
      icon: 'check-circle',
      onClick: publishSite
    }
  ];
};

export default AppMenu;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Config/Menus/AppMenu.jsx